import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { ProjectType } from '../../models/api.models';
import { TableModule } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-master-role-list',
  standalone: true,
  imports: [CommonModule, TableModule, ToastModule, FormsModule],
  providers: [MessageService],
  templateUrl: './master-role-list.component.html',
  styles: [`
    .master-card {
      background: white;
      border-top: 4px solid #1e293b;
    }
  `]
})
export class MasterRoleListComponent implements OnInit {
  roles: any[] = [];
  loading: boolean = false;
  selectedClient: ProjectType = ProjectType.SVN;
  projectTypes = [
    { label: 'SVN', value: ProjectType.SVN },
    { label: 'SOVRN', value: ProjectType.SOVRN },
    { label: 'CAPITAL', value: ProjectType.CAPITAL }
  ];

  constructor(
    private apiService: ApiService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadRoles();
  }

  loadRoles(): void {
    this.loading = true;
    this.apiService.getRolesByClientMaster(this.selectedClient).subscribe({
      next: (response) => {
        this.roles = response && response.data ? response.data : [];
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load master roles'
        });
        this.loading = false;
      }
    });
  }

  switchClient(client: ProjectType): void {
    this.selectedClient = client;
    this.loadRoles();
  }
}
